import { defineQuery } from 'next-sanity'
import { imageFields, inlineCtaFields } from '../atoms'

export const subjectSliderFields = `
  _id,
  _type,
  title,
  showTitle,
  titleAligned,
  cardSize,
  subTitle,
  backgroundColor,
  items[]{
    title,
    description,
    image {
      ${imageFields},
      containImage
    },
    cta {
      ${inlineCtaFields}
    }
  }
`

export const SUBJECT_SLIDER_QUERY = defineQuery(/* groq */ `
  *[_type == "subject-slider"][0]{
    ${subjectSliderFields}
  }
`)
